module.exports = __webpack_public_path__ + "static/media/arrows-resize-v.963a991d.svg";